import React from 'react';
//import ReactDOM from "react-dom/client";
import preval from 'preval.macro'
import {
  Button,
  Col,
  Container,
  //Alert,
  //Nav,
  //Navbar,
  Row,
  Form,
  //Input,
  Stack
} from 'react-bootstrap';
import '../../App.css';
import utils from '../../utils'
import EcuComps2 from '../../comp/EcuComps2'
import MyEcu from '../../MyEcu';
//import PTextLabel from '../../comp/p/PTextLabel'
//import { wait } from '@testing-library/user-event/dist/utils';
//////import { confirm } from "react-confirm-box";
// import AuthService from '../../services/auth-service';
import LoadingSpinner from "../../comp/gen/LoadingSpinner"
import UserAuthRequired from "../../comp/gen/UserAuthRequired"

// ****************************************************************************

export default class MP_STANDARD extends React.Component {
  constructor(props) {    
    super(props); 
    // ecu
    
    
    
    
    
    this.ecu = new MyEcu(MyEcu.ECU_TYPE.MP48__MP8C, 9600)
    //this.ecu = new MyEcu(MyEcu.ECU_TYPE.DI60, 38400)





    this.ecu.progressChanged = this.ecu_progress_changed.bind(this)
    this.ecu.comPortChanged = this.ecu_com_port_changed.bind(this)
    // ref
    this.client_select = React.createRef()
    this.DI_client_select = React.createRef()
    this.sub_client_code_text = React.createRef()
    this.model_code_text = React.createRef()
    this.id_pcb_w0_text = React.createRef()
    this.id_pcb_w1_text = React.createRef()
    this.id_pcb_select = React.createRef()
    // state
    this.state = { 
      stay_in_boot_after_fix_checked: false,
      working: 0,
      ecu_comps: [],            
      usb_selected: false,
      usbProductId: "",
      usbVendorId: "",      
    };
    // debug
    if ("serial" in navigator) {
      console.log("supported !") 
    }
  }
  
  ecu_com_port_changed(o) {
    if (o === undefined) {
      this.setState({
        usb_selected: false,
        usbProductId: "",
        usbVendorId: "",
      })
      return 
    }
    this.setState({
      usb_selected: true,
      usbProductId: o.usbProductId,
      usbVendorId: o.usbVendorId,
    })
  }

  ecu_progress_changed(o) {
    //console.log(o)
    if (o.type == "_working") {
      this.setState({
        working: o.data
      })
    } else {
      this.setState(prevState => ({
        ecu_comps: [
          ...prevState.ecu_comps,
          o,
        ]
      }))
    }    
    //console.log("STATE")
    //console.log(this.state)
  }

  async handleButtonClearClick() {
    await this.setState({ ecu_comps: [] })
    console.log(this.state)
  }
  async handleButtonFixClientClick() {
    var selected_client = this.client_select.current.value
    var stay_in_boot_after_fix = this.state.stay_in_boot_after_fix_checked
    if (selected_client === "0") {
      console.log("nothing selected")
      return
    }
    console.log("selected_client : " + selected_client)
    console.log("stay_in_boot_after_fix_checked : " + stay_in_boot_after_fix)
    //return
    await this.setState({ ecu_comps: [] })
    this.ecu.fixClient(selected_client, stay_in_boot_after_fix)
  }
  async handleButtonFixDirInjClientClick() {
    var selected_client = this.DI_client_select.current.value
    if (selected_client === "0") {
      console.log("nothing selected")
      return
    }
    console.log("selected_client : " + selected_client)
    //return
    await this.setState({ ecu_comps: [] })
    this.ecu.fixDirInjClient(selected_client)
  }
  async handleButtonSetSubClientClick() {
    await this.setState({ ecu_comps: [] })
    //this.sub_client_code_text.current.value
    var value = this.sub_client_code_text.current.value
    this.ecu.changeSubClient(value)
  }
  async handleButtonSetModelCodeClick() {
    await this.setState({ ecu_comps: [] })
    var value = this.model_code_text.current.value
    this.ecu.changeModelCode(value)
  }
  async handleButtonSetIdPcbClick() {
    await this.setState({ ecu_comps: [] })
    //this.sub_client_code_text.current.value
    var w0 = this.id_pcb_w0_text.current.value
    var w1 = this.id_pcb_w1_text.current.value
    this.ecu.changeIdPcb(w0, w1)
  }
  async handleButtonReadEcuInfoClick() {
    await this.setState({ ecu_comps: [] })
    this.ecu.readEcuInfo()
  }
  async handleButtonLeaveBootClick() {
    await this.setState({ ecu_comps: [] })
    this.ecu.leaveBoot()
  }
  async handleButtonSetComPortClick() {
    await this.setState({ ecu_comps: [] })
    this.ecu.selectComPort()
  }
  async handleButtonSetProdMarkerClick() {
    // const options = {
    //   labels: {
    //     confirmable: "Confirm",
    //     cancellable: "Cancel"
    //   }
    // }
    if (!window.confirm("Are you sure?")) return 
    await this.setState({ ecu_comps: [] })
    this.ecu.setProdMarker(0x01)
  }

  handleEcuTypeChange = (event) => {
    console.log(event.target.value)
    this.ecu.setEcuType(event.target.value)
    switch (event.target.value) {
      default:
        this.ecu.setBaudRate(9600)
        break;
      case MyEcu.ECU_TYPE.MP48__MP8C:
        this.ecu.setBaudRate(9600)
        break;
      case MyEcu.ECU_TYPE.MP32__MP48_OBD:
        this.ecu.setBaudRate(9600)
        break;
      case MyEcu.ECU_TYPE.MP32_NEW:
        this.ecu.setBaudRate(38400)
        break;
      case MyEcu.ECU_TYPE.DI60:
        this.ecu.setBaudRate(38400)
        break;
    }
  }
  handleIdPcbChange = (event) => {
    console.log(event.target.value)
    var c = utils.getIdPcbFromName(event.target.value)
    if (c === undefined) return
    this.id_pcb_w0_text.current.value = c.w0
    this.id_pcb_w1_text.current.value = c.w1
  }
  handleSubClientKeyPress = e => {
    const re = /[0-9a-fA-F]+/g;
    if (!re.test(e.key)) {
      e.preventDefault()
    }
    //console.log(this.sub_client_code_text.current.value)
    if (this.sub_client_code_text.current.value.length >= 4) {
      e.preventDefault()
    }
  }
  handleModelCodeKeyPress = e => {
    const re = /[0-9a-fA-F]+/g;
    if (!re.test(e.key)) {
      e.preventDefault()
    }
    if (this.model_code_text.current.value.length >= 2) {
      e.preventDefault()
    }
  }

  render() { 
    //console.log(this.props)
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />    
    if (!utils.userHasRole(this.props.authStatus.user, "USER")) return <UserAuthRequired notallowed />

    var buttons_en = !(this.state.working === 1)
    return (
      <>          
        <Container>            
            <Row style={{ marginTop: "15px" }}> 
              <Col>
                <Row>
                  <Col>
                    <img src={process.env.PUBLIC_URL + '/logo_landi.png'} className="App-logo2" alt="logo" />
                  </Col>
                  <Col>
                    <p>Build Date: {preval`module.exports = new Date().toLocaleString();`}</p>
                    <Button 
                        variant="outline-secondary" 
                        disabled={!buttons_en}  
                        onClick={e => this.handleButtonSetComPortClick(e)}>SET COM PORT</Button>                    
                    {/* <PTextLabel visible={this.state.usb_selected} label="usbProductId" value={this.state.usbProductId} />
                    <PTextLabel visible={this.state.usb_selected} label="usbVendorId" value={this.state.usbVendorId} /> */}
                  </Col>
                </Row>
                <Stack direction='horizontal' gap={3}>
                </Stack>
              </Col>
              <Col>
                <Stack gap={3}>
                  <Button 
                      variant="success" 
                      disabled={!buttons_en} 
                      onClick={e => this.handleButtonReadEcuInfoClick(e)}>READ ECU INFO</Button>
                  <Button 
                      variant="success" 
                      disabled={!buttons_en} 
                      onClick={e => this.handleButtonLeaveBootClick(e)}>LEAVE BOOT</Button>              
                </Stack>
              </Col> 
            </Row>
            <Row style={{ marginTop: "15px" }}>
              <Col>
                <Stack gap={3}>
                  <Row>
                    <Col>  
                      <Form.Select defaultValue={this.ecu.ecu_type} onChange={this.handleEcuTypeChange} aria-label="">
                        <option disabled value="0">Select an option...</option>
                        <option value={MyEcu.ECU_TYPE.MP48__MP8C}>MP48, MP8C</option>
                        <option value={MyEcu.ECU_TYPE.MP32__MP48_OBD}>MP32, MP48 OBD</option>
                        <option value={MyEcu.ECU_TYPE.MP32_NEW}>MP32 New (EXR)</option>
                        <option value={MyEcu.ECU_TYPE.DI60}>DI60</option>
                      </Form.Select>
                    </Col>
                  </Row>                  


                  <Row>
                    <Col>
                      <Form.Select defaultValue="LANDI" ref={this.client_select} aria-label="Default select example">
                        <option disabled value="0">Select an option...</option>
                        <option value="AEB">AEB</option>
                        <option value="LANDI">LANDI</option>
                        <option value="LOVATO">LOVATO</option>
                        <option value="EMMEGAS">EMMEGAS</option>
                        <option value="ENERGY_REFORM">ENERGY REFORM</option>
                        <option value="CLIENT_FC">CLIENT FC (sub client)</option>
                        <option value="CLIENT_FD">CLIENT FD (group AEB)</option>
                        <option value="CLIENT_FF">CLIENT FF (neutro)</option>
                      </Form.Select>
                      <Form.Check
                        type="checkbox"
                        onChange={e => this.setState({ stay_in_boot_after_fix_checked: e.target.checked })}
                        label={`Stay in boot after fix`}
                        id={`disabled-default-checkbox`} />
                    </Col>
                    <Col>
                      <Button 
                          variant="primary" 
                          disabled={!buttons_en} 
                          onClick={e => this.handleButtonFixClientClick(e)}>FIX CLIENT</Button>
                    </Col>
                  </Row>


                  <Row>
                    <Col>
                      <Form.Control
                        type="text"
                        defaultValue="0000" 
                        ref={this.sub_client_code_text}
                        onKeyPress={e => this.handleSubClientKeyPress(e)}
                        />                    
                    </Col>
                    <Col>
                      <Button 
                        variant="primary" 
                        disabled={!buttons_en} 
                        onClick={e => this.handleButtonSetSubClientClick(e)}>CHANGE SUB CLIENT</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <Form.Select onChange={this.handleIdPcbChange} defaultValue="" ref={this.id_pcb_select} aria-label="">
                        <option disabled value="">Select an option...</option>
                        {
                          utils.idPcbItems.map((option, index) => (
                            <option key={index} value={option.name}>
                              {option.name}
                            </option>
                          ))
                        }
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Control
                        type="text"
                        defaultValue="0000" 
                        ref={this.id_pcb_w0_text}
                        // onKeyPress={e => this.handleSubClientKeyPress(e)}
                        />                    
                    </Col>
                    <Col>
                      <Form.Control
                        type="text"
                        defaultValue="0000" 
                        ref={this.id_pcb_w1_text}
                        // onKeyPress={e => this.handleSubClientKeyPress(e)}
                        />                    
                    </Col>
                    <Col xs={4}>
                      <Button 
                        variant="primary" 
                        disabled={!buttons_en} 
                        onClick={e => this.handleButtonSetIdPcbClick(e)}>CHANGE ID PCB</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button variant="primary" disabled>
                        Do not press this button ...
                      </Button>
                      {' '}
                      <Button 
                          variant="outline-secondary" 
                          disabled={!buttons_en}  
                          onClick={e => this.handleButtonSetProdMarkerClick(e)}>SET PROD MARKER</Button>
                    </Col>
                  </Row>


                  <Row>
                    {' '}
                  </Row>
                  <Row>
                    {' '}
                  </Row>
                  <Row>
                    {' '}
                  </Row>


                  <Row>
                    <Col>
                      <Form.Control
                        type="text"
                        defaultValue="" 
                        ref={this.model_code_text}
                        onKeyPress={e => this.handleModelCodeKeyPress(e)}
                        />                    
                    </Col>
                    <Col>
                      <Button 
                        variant="primary" 
                        disabled={!buttons_en} 
                        onClick={e => this.handleButtonSetModelCodeClick(e)}>CHANGE MODEL CODE</Button>
                    </Col>
                  </Row>


                  <Row>
                    {' '}
                  </Row>
                  <Row>
                    {' '}
                  </Row>
                  <Row>
                    {' '}
                  </Row>


                  <Row>
                    <Col>
                      <Form.Select defaultValue="" ref={this.DI_client_select} aria-label="">
                        <option disabled value="">Select an option...</option>
                        {
                          utils.dirInjClients.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.name}
                            </option>
                          ))
                        }
                      </Form.Select>                      
                    </Col>
                    <Col>
                      <Button 
                          variant="primary" 
                          disabled={!buttons_en} 
                          onClick={e => this.handleButtonFixDirInjClientClick(e)}>FIX DI60 CLIENT</Button>
                    </Col>
                  </Row>

                </Stack>
              </Col>

              <Col>      
                <Stack gap={3}>        
                  <Button 
                    variant="info" 
                    onClick={e => this.handleButtonClearClick(e)}>CLEAR RESULT</Button>                  
                  <EcuComps2 ecu_comps={this.state.ecu_comps} />
                </Stack>
              </Col>
            </Row>
        </Container>        
      </>
    )
  }
}
